import React, { useContext } from 'react';
import { ReactComponent as MuteIcon } from '../../../../../../resource/MuteIcon.svg';
import { ReactComponent as UnmuteIcon } from '../../../../../../resource/UnmuteIcon.svg';
import RoundIconBackground from '../../../RoundIconBackground/RoundIconBackground';
import { roundIconBgTypes } from '../../../../constants/common';
import { SipPhoneContext } from '../../../../../../components/SipPhoneProvider';

const OnOffMicrophone = () => {
  const { microphoneIsMuted, toggleMuteMicrophone } =
    useContext(SipPhoneContext);

  return (
    <RoundIconBackground
      onClick={toggleMuteMicrophone}
      containerType={roundIconBgTypes.transparent}
      renderIcon={({ className }) =>
        microphoneIsMuted ? (
          <MuteIcon className={className} />
        ) : (
          <UnmuteIcon className={className} />
        )
      }
    />
  );
};

export default OnOffMicrophone;
